import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6cbe2889"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "abnormal" }
const _hoisted_2 = { class: "swiper-wrapper" }
const _hoisted_3 = { class: "abnormal-item" }
const _hoisted_4 = { class: "abnormal-item-name" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "new-tag" }, "NEW", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"flex":"1"} }, null, -1))
const _hoisted_7 = { class: "abnormal-item-num" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-angle-right icon-size",
  style: {"margin-left":"8px","font-size":"18px"}
}, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "abnormal-item"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "abnormal-item-name" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "fa fa-angle-right icon-size",
  style: {"margin-left":"8px","font-size":"18px"}
}, null, -1))

import { ref, watch, watchEffect, Ref, computed, onMounted, onUnmounted } from 'vue'
import { t } from '@/plugins/i18n'
import { useRtfix, isD2C, isJA } from '@/store'
import { OrderTypeItem } from './UserOrder.vue'
import { UseType } from '@/common/const'
import { TaEvent, taTrack } from '@/util/buryingPoint'
import { DeliveryAbnormalOrderCount } from '@/apis/interface/customer'
import { request } from '@/config/request/interceptors'
import { useRouter } from 'vue-router'

enum ENUM_ABNORMAL_TYPE {
  /** 异常订单 */
  ABNORMAL_ORDER = '1',
  /** API自动下单异常 */
  ABNORMAL_AUTO_ORDER = '2',
  /** 待支付账单 */
  ABNORMAL_BILL = '3',
  /** OEM待确认报价 */
  ANNORMAL_OEM_QUOTE = '4',
  /** 待确认补货计划 */
  ABNORMAL_REPLENISHMENT = '5'
}


export default /*#__PURE__*/_defineComponent({
  props: {
    workbenchOrderInfo: { type: null, required: true }
  },
  setup(__props: any) {

const props = __props as {
  workbenchOrderInfo: DeliveryAbnormalOrderCount
}
_useCssVars(_ctx => ({
  "0d1eef07": (animationDuration.value + "s"),
  "4a50d74d": (isPaused.value ? "paused" : "running")
}))

const abnormalLis2C: OrderTypeItem[] = [
  {
    name: t('异常订单'),
    num: 0,
    path: 'AbnormalOrder',
    orderStatus: ENUM_ABNORMAL_TYPE.ABNORMAL_ORDER,
    position: 'abnormal_order'
  },
  {
    name: t('API自动下单异常'),
    num: 0,
    path: 'SyncOrder',
    orderStatus: ENUM_ABNORMAL_TYPE.ABNORMAL_AUTO_ORDER,
    position: 'abnormal_api_auto_order'
  },
  {
    name: t('待支付账单'),
    num: 0,
    path: 'BillList',
    orderStatus: ENUM_ABNORMAL_TYPE.ABNORMAL_BILL,
    position: 'to_be_paid_bill'
  },
  {
    name: t('OEM待确认报价'),
    num: 0,
    path: 'oemSourceList',
    orderStatus: ENUM_ABNORMAL_TYPE.ANNORMAL_OEM_QUOTE,
    position: 'to_be_confirmed_oem_quotation'
  }
]

const abnormalLis2B: OrderTypeItem[] = [
  {
    name: t('异常订单'),
    num: 0,
    path: 'AbnormalOrder',
    orderStatus: ENUM_ABNORMAL_TYPE.ABNORMAL_ORDER,
    position: 'abnormal_order'
  },
  {
    name: t('待支付账单'),
    num: 0,
    path: 'BillList',
    orderStatus: ENUM_ABNORMAL_TYPE.ABNORMAL_BILL,
    position: 'to_be_paid_bill'
  },
  {
    name: t('待确认补货计划1'),
    num: 0,
    path: 'ReplenishmentList',
    orderStatus: ENUM_ABNORMAL_TYPE.ABNORMAL_REPLENISHMENT,
    position: 'pending_confirmation_replenishment_plan'
  },
  {
    name: t('OEM待确认报价'),
    num: 0,
    path: 'oemSourceList',
    orderStatus: ENUM_ABNORMAL_TYPE.ANNORMAL_OEM_QUOTE,
    position: 'to_be_confirmed_oem_quotation'
  }
]

// 没有申报信息。则展示
const isNoDeclare = ref(false)
const isPaused = ref(false)
const animationDuration = ref(10) // 动画持续时间，单位秒

onMounted(async () => {
  if (isJA()) {
    const res = await request.customer.customer.shopGetCustomerShopById()
    isNoDeclare.value = !res.data?.declarePlatformCode
  }
})

const abnormalList: Ref<OrderTypeItem[]> = ref(isD2C() ? abnormalLis2C : abnormalLis2B)



watchEffect(() => {
  const newArr = [...abnormalList.value]
  const workbenchOrderInfo = props?.workbenchOrderInfo
  newArr.map((item) => {
    if (item.orderStatus === ENUM_ABNORMAL_TYPE.ABNORMAL_ORDER) {
      item.num = (
        Number(workbenchOrderInfo?.abnormalOrderCount) +
        Number(workbenchOrderInfo?.wholeProcessOrderCount) +
        Number(workbenchOrderInfo?.skuProcessOrderCount)) || 0
    } else if (item.orderStatus === ENUM_ABNORMAL_TYPE.ABNORMAL_AUTO_ORDER) {
      item.num = workbenchOrderInfo?.notFinishedOrderCount || 0
    } else if (item.orderStatus === ENUM_ABNORMAL_TYPE.ABNORMAL_BILL) {
      item.num = workbenchOrderInfo?.unpaidBillNum || 0
    } else if (item.orderStatus === ENUM_ABNORMAL_TYPE.ANNORMAL_OEM_QUOTE) {
      item.num = workbenchOrderInfo?.waitConfirm || 0
    } else if (item.orderStatus === ENUM_ABNORMAL_TYPE.ABNORMAL_REPLENISHMENT) {
      item.num = workbenchOrderInfo?.noConfirmReplenishPlanCount || 0
    }
  })
})

const router = useRouter()
const handleAppLink = (item: OrderTypeItem) => {
  taTrack({
    event: TaEvent.BTN_CLICK,
    value: {
      position: item.position
    }
  })
  if (item.orderStatus === ENUM_ABNORMAL_TYPE.ANNORMAL_OEM_QUOTE) {
    window.location.href = window.location.origin + '/oem/order/oemSourceList?status=13,16'
  } else if (item.orderStatus === ENUM_ABNORMAL_TYPE.ABNORMAL_REPLENISHMENT) {
    return router.push(useRtfix(item.path as string, { query: { planStatus: 1 } }))
  } else {
    return router.push(useRtfix(item.path as string))
  }
}

// 计算实际显示的项数
const visibleItemCount = computed(() => {
  let count = abnormalList.value.length
  if (isNoDeclare.value) count++
  return count
})

// 暂停轮播
const pauseSwiper = () => {
  console.log(111)
  isPaused.value = true
}

// 继续轮播
const resumeSwiper = () => {
  console.log(222)
  isPaused.value = false
}

// 加速轮播
const speedUpSwiper = () => {
  animationDuration.value = Math.max(10, animationDuration.value - 5)
}

// 减速轮播
const speedDownSwiper = () => {
  animationDuration.value += 5
}

// 鼠标事件处理
const handleMouseEnter = () => {
  pauseSwiper()
}

const handleMouseLeave = () => {
  resumeSwiper()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "abnormal-list swiper-content",
      onMouseenter: pauseSwiper,
      onMouseleave: resumeSwiper
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((isNoDeclare.value ? 2 : 1), (i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
            (isNoDeclare.value)
              ? (_openBlock(), _createElementBlock("div", {
                  class: "swiper-item",
                  key: i
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", {
                      class: "abnormal-item-content",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(_unref(useRtfix)('setupShop', { query: { name: 'ShopExpress' } }))))
                    }, [
                      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('海关申报信息')), 1),
                      _hoisted_5,
                      _hoisted_6,
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('待填写')), 1)
                    ]),
                    _hoisted_8
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(abnormalList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${index}-${i}`,
                class: "swiper-item"
              }, [
                (!_unref(isJA)() && item.orderStatus === ENUM_ABNORMAL_TYPE.ABNORMAL_REPLENISHMENT)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", {
                        class: "abnormal-item-content",
                        onClick: ($event: any) => (handleAppLink(item))
                      }, [
                        _createElementVNode("span", _hoisted_11, _toDisplayString(item.name), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(["abnormal-item-num", Number(item?.num) > 0 ? 'red' : ''])
                        }, _toDisplayString(Number(item?.num) > 99 ? '99+' : item.num), 3)
                      ], 8, _hoisted_10),
                      _hoisted_12
                    ]))
              ]))
            }), 128))
          ], 64))
        }), 128))
      ])
    ], 32)
  ]))
}
}

})